// import variables from '../variables';
/* eslint-disable */
const MuiTabs = {};

export default MuiTabs;
